/**
 *
 * ChannelList
 *
 */

import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import { getIn } from 'utils/helpers';
import { connect } from 'react-redux';
import { PLAN_SELECTION } from 'containers/RootModal/constants';
import { INTUITIVE_MODAL } from 'containers/RootModal/constants';
import {
  Wrapper,
  Title,
  StatusFilterList,
  StatusFilterOption,
  StatusFilterOptionItem,
  RowHyperlink,
  TableData,
  StyledFilter,
  FilterButton
} from './styledComponents';
import Button from '../../../components/Button';
import EmptyList from './EmptyList';
import H1 from 'components/H1';
import Spinner from 'components/Spinner'
import { setModal } from 'containers/RootModal/actions';
import { deleteChannelRequest, setClientFilter, setStatusFilter, fetchChannelsRequest } from '../actions';
import PopoverLinklist from 'components/Popover/PopoverLinklist';
import Table from "components/Table";
import Icon from 'components/Icon';
import { selectAllChannels, selectStatusFilter, selectClientFilter, selectIsFetching, selectClients } from '../selectors';
import { selectIsPhotographer } from '../../App/selectors';
import { createStructuredSelector } from 'reselect';

const columns = [
  {
    header: 'client',
    path: 'clientName',
    noSort: true,
    customRow: (rowData) => (
      <TableData isLink onClick={() => rowData.changeClientFilter({ id: rowData.clientId, name: rowData.clientName })}>{rowData.clientName}</TableData>
    )
  },
  {
    header: 'channel name / gallery link',
    path: 'name',
    noSort: true,
    customRow: (rowData) => (
      <RowHyperlink onClick={() => window.open(rowData.url)}>{rowData.name}</RowHyperlink>
    )
  },
  {
    header: 'last updated',
    path: 'updated_at',
    type: 'date'
  },
  {
    header: '',
    type: "dropdown",
    customRow: ({ permissionRole, name, id, url, deleteChannel }) => (
      <PopoverLinklist links={
        [
          { title: 'edit channel', href: 'channels/' + id + '/edit' },
          { title: 'View Gallery', onClick: () => window.open(url) },
          { title: 'View Leads', href: 'leads/' + id },
          !['lite', 'plus'].includes(permissionRole) ? { title: 'View Analytics', href: 'analytics/' + id } : null,
          permissionRole === "super_admin"
            ? {
              title: 'delete channel',
              style: 'danger',
              onClick: () => {
                if (confirm(`You are about to delete the channel ${name}. This will delete all of the photos and data collected for the channel as well.This cannot be undone. Are you sure you want to delete this channel?`)) {
                  deleteChannel(id);
                }
              }
            }
            : null
        ].filter(x => x)
      } />
    )
  },
]

const getData = ({ channels, permissionRole, deleteChannel, changeClientFilter }) => {
  return channels ? channels.map(c => (
    {
      ...c,
      clientId: c.client && c.client.id,
      clientName: c.client && c.client.name,
      permissionRole,
      deleteChannel,
      changeClientFilter
    }
  )) : null;
}

class ChannelList extends Component {
  state = {
    sort: { path: 'updated_at', isDesc: true },
    page: 1
  }

  componentDidMount() {
    this.props.fetchChannels(this.getFilter());
  }

  componentDidUpdate(prevProps) {
    const { statusFilter, clientFilter, fetchChannels } = this.props;
    if (prevProps.statusFilter !== statusFilter || JSON.stringify(prevProps.clientFilter) !== JSON.stringify(clientFilter)) {
      fetchChannels({ ...this.getFilter(), status: statusFilter, client_id: clientFilter ? clientFilter.id : null, page: 1 })
    }
  }

  handlePageChange = (page) => {
    this.props.fetchChannels({ ...this.getFilter(), page });
  }

  handleSortChanged = (sortObj) => {
    this.setState({ sort: sortObj }, () => {
      this.props.fetchChannels({ ...this.getFilter(), page: 1 });
    });
  }

  getFilter = () => {
    return {
      page: this.props.paging.currentPage,
      status: this.props.statusFilter,
      client_id: this.state.clientFilter ? this.state.clientFilter.id : null,
      sort_name: this.state.sort.path,
      sort_direction: this.state.sort.isDesc ? 'desc' : 'asc',
    };
  }

  render() {
    const {
      clients,
      statusFilter,
      changeStatusFilter,
      clearClientFilter,
      clientFilter,
      isFetching,
      isPhotographer,
      remainingLiteChannel,
      remainingTrialChannel,
      ifUnlimitiedPhotographer,
      openPasswordRequirementsModal,
      openIntuitiveModal,
      ifLitePhotographer,
      subscriptionCurrentStatus,
      remaingDaysInRenewel,
      paging,
    } = this.props;
    const data = getData(this.props);
    const isEmpty = data && data.length > 0 ? false : true;
    const tableProps = { isFetching, data, columns, ...paging, onPageChange: this.handlePageChange, sortChanged: this.handleSortChanged };
    const newChannelOnClick = () => {
      (!remainingLiteChannel && ifLitePhotographer && subscriptionCurrentStatus)
        ? openIntuitiveModal(remaingDaysInRenewel)
        : openPasswordRequirementsModal()
    }
    return (
      <Wrapper>
        <Title>
          <H1>Channels</H1>
          { // NOTE: Could be mapped over if multiple filters can be added
            clientFilter && !isFetching && (
              <StyledFilter>
                <FilterButton onClick={() => clearClientFilter()}><Icon size='8' name='close' /></FilterButton>
                {` Client: ${clientFilter.name}`}
              </StyledFilter>
            )
          }
          {!isEmpty && (
            isPhotographer && !(remainingLiteChannel || remainingTrialChannel || ifUnlimitiedPhotographer || ifLitePhotographer)
              ? <Button onClick={newChannelOnClick}>New Channel</Button>
              : <Link to='channels/new'><Button>New Channel</Button></Link>
          )}
        </Title>
        <StatusFilterList>
          {
            ['active', 'archived'].map((f) =>
              <StatusFilterOption key={f} className={f === statusFilter ? 'active' : null} onClick={() => changeStatusFilter(f)}>
                <StatusFilterOptionItem isActive={f === statusFilter}>
                  {f}
                </StatusFilterOptionItem>
              </StatusFilterOption>
            )}
        </StatusFilterList>
        {isFetching && !data
          ? <Spinner />
          : (isEmpty ? <EmptyList /> : <Table {...tableProps} />)
        }
      </Wrapper>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  channels: selectAllChannels(),
  statusFilter: selectStatusFilter(),
  clientFilter: selectClientFilter(),
  isFetching: selectIsFetching(),
  clients: selectClients(),
  isPhotographer: selectIsPhotographer(),
  remainingLiteChannel: state => state.app.user.remaining_lite_channel,
  remainingTrialChannel: state => state.app.user.remaining_trial_channel,
  ifUnlimitiedPhotographer: state => state.app.user.if_unlimitied_photographer,
  ifLitePhotographer: state => state.app.user.if_lite_photographer,
  subscriptionCurrentStatus: state => state.app.user.subscription_current_status,
  remaingDaysInRenewel: state => state.app.user.remaining_days_in_renewel,
  permissionRole: state => state.app.user.permission_role,
  paging: state => state.channels.paging,
});

;
const mapDispatchToProps = (dispatch, _ownProps) => {
  return {
    openPasswordRequirementsModal: () => dispatch(setModal({ modalType: PLAN_SELECTION })),
    openIntuitiveModal: (days) => dispatch(setModal({ modalType: INTUITIVE_MODAL, modalProps: { remainingDays: days } })),
    deleteChannel: (id) => dispatch(deleteChannelRequest(id)),
    changeClientFilter: (val) => dispatch(setClientFilter(val)),
    clearClientFilter: () => dispatch(setClientFilter('')),
    changeStatusFilter: (val) => dispatch(setStatusFilter(val)),
    fetchChannels: (params) => dispatch(fetchChannelsRequest(params)),
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(ChannelList);



// WEBPACK FOOTER //
// ./src/containers/ChannelsPage/ChannelList/index.js